module.exports = __webpack_public_path__ + "media/agent_1_shake.f0154e93.mp3";